import React from 'react'

import style from './ColumnHeader.module.scss'

interface Props {
  children: any
  direction?: SortingDirection
  onSortClick?: (direction: SortingDirection) => void
}

export enum SortingDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export function ColumnHeader({ children, onSortClick, direction }: Props) {
  function handleOnClick() {
    if (onSortClick === undefined) {
      return
    }

    if (direction === null) {
      return onSortClick(SortingDirection.ASC)
    }

    onSortClick(direction === SortingDirection.ASC ? SortingDirection.DESC : SortingDirection.ASC)
  }

  return (
    <th>
      {onSortClick ? (
        <div onClick={handleOnClick} className={style.sortLink}>
          {children}
          &nbsp;{direction === undefined ? '' : (direction === SortingDirection.DESC ? '▼' : '▲')}
        </div>
      ) : (
        children
      )}
    </th>
  )
}